import { atom } from 'recoil';

export const fleetMaintenanceTypesReloadListState = atom<boolean>({
  key: 'app.fleet.maintenanceTypes.reload',
  default: false,
});

export const fleetMaintenanceTypesFiltersState = atom<{
  page: number;
  search: string;
}>({
  key: 'app.fleet.maintenanceTypes.filters',
  default: {
    page: 1,
    search: '',
  },
});
